import { reportJsonParseException } from '@/common/exception'

const Network = Mach.requireModule('Network')

// 常规请求，只有url是必传
const commonRequest = ({ method, dataType, url, data, headers, option }: { method?: string; dataType?: string; url: string; data?: any; headers?: any; option?: { validateCode?: boolean } }) => {
  const { fingerPrint, fingerprint, ...newData } = data || {}
  const { validateCode = true } = option || {}
  const params = {
    dataType: dataType || 'json',
    url,
    method: method || 'GET',
    params: (method || 'GET') === 'GET' ? newData || null : null,
    data: (method || 'GET') === 'POST' ? newData || {} : null,
    headers: headers || {},
  }
  return new Promise<any>((resolve, reject) => {
    // 设备指纹通过requestWx方法请求，fingerprint参数在端内自动写入
    Network[fingerPrint || fingerprint ? 'requestWx' : 'request'](params, function (result: any) {
      if (result.error) {
        reportJsonParseException({
          url,
          error: result.error,
          errorType: 'native_error',
        })
        reject(result.error)
      } else {
        if (!validateCode) {
          resolve(result.data)
          return
        }
        if (result.data && result.data.code === 0) {
          resolve(result.data)
        } else {
          reject(result.data)
        }
      }
    })
  })
}

export default commonRequest
